import { useState, useEffect, useRef } from "react";
import { Edit2, Calendar, Eye } from "iconsax-react";

const Popup = ({ onEdit, onPreview, onEventPage }) => {
  const [isOpen, setIsOpen] = useState(false);
  const popupRef = useRef();

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        handleClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative" ref={popupRef}>
      <button onClick={handleClick} className="focus:outline-none">
        {/* <More size="24" color="currentColor" /> */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            fill="#000"
            d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0-4 0m0-6a2 2 0 1 0 4 0a2 2 0 0 0-4 0m0 12a2 2 0 1 0 4 0a2 2 0 0 0-4 0"
          />
        </svg>
      </button>
      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg z-20">
          <div onClick={handleClose} className="py-1">
            <div
              onClick={onEdit}
              className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
            >
              <Edit2 size="16" style={{ marginRight: 8 }} /> Edit Event
            </div>
            <div
              onClick={onPreview}
              className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
            >
              <Eye size="16" style={{ marginRight: 8 }} /> Preview Page
            </div>
            <div
              onClick={onEventPage}
              className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
            >
              <Calendar size="16" style={{ marginRight: 8 }} /> Event Page
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Popup;
